/*
 * @FilePath     : /es-package/packages/es-mpx-storage/lib/creator.js
 * @Author       : LiYang
 * @Date         : 2022-02-08 16:23:28
 * @LastEditTime : 2022-02-08 20:35:47
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

import proto from './alias'

function Storage(storage) {
  this.storage = storage
}

export default function create(storage) {
  Storage.prototype = proto;
  Storage.prototype.constructor = Storage;

  return new Storage(storage)
}
